import WsProvider from './provider/WSProvider'
var base64 = require('base64_js');
var serviceName = "islem";
var seoService = {
    islemListesi(baslangic, limit) {
        var userDataEstas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataEstas"))));
        var param = {
            data: {
                yonetimId: userDataEstas["yonetimId"],
                userToken: userDataEstas["token"],
                firmaKodu: userDataEstas["firmaKodu"],
                baslangic: 0,
                limit: 10,
                methodName: "islemListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    }
}

export default seoService

